import _regeneratorRuntime from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import getPrettyError from '../../../../../utils/getPrettyError';
import rootReducer from './reducers/rootReducer';
import { saveCsvContent } from '../apiClients/csvDataClient';
var CsvStateContext = React.createContext(null);
var CsvDispatchContext = React.createContext(null);

function CsvProvider(_ref) {
  var children = _ref.children;

  var _React$useReducer = React.useReducer(rootReducer, null),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  return React.createElement(CsvStateContext.Provider, {
    value: state
  }, React.createElement(CsvDispatchContext.Provider, {
    value: dispatch
  }, children));
}

function useCsvState() {
  var context = React.useContext(CsvStateContext);

  if (context === undefined) {
    throw new Error('useCsvState must be used within a CsvStateContext');
  }

  return context;
}

function useCsvDispatch() {
  var context = React.useContext(CsvDispatchContext);

  if (context === undefined) {
    throw new Error('useCsvDispatch must be used within a CsvDispatchContext');
  }

  return context;
}

function reset(dispatch, workspace, path) {
  dispatch({
    type: 'reset',
    payload: {
      workspace: workspace,
      path: path
    }
  });
}

function save(_x, _x2) {
  return _save.apply(this, arguments);
}

function _save() {
  _save = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(dispatch, documentState) {
    var filePath, fileCsvData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            dispatch({
              type: 'document_saving'
            });
            _context.t0 = _regeneratorRuntime.keys(documentState.csvData);

          case 3:
            if ((_context.t1 = _context.t0()).done) {
              _context.next = 12;
              break;
            }

            filePath = _context.t1.value;
            fileCsvData = documentState.csvData[filePath];

            if (!(fileCsvData.edits === null)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("continue", 3);

          case 8:
            _context.next = 10;
            return saveCsvContent(documentState.workspace, filePath, fileCsvData.edits);

          case 10:
            _context.next = 3;
            break;

          case 12:
            dispatch({
              type: 'document_saved'
            });
            _context.next = 18;
            break;

          case 15:
            _context.prev = 15;
            _context.t2 = _context["catch"](0);
            dispatch({
              type: 'error',
              payload: getPrettyError(_context.t2)
            });

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 15]]);
  }));
  return _save.apply(this, arguments);
}

function undo(dispatch) {
  dispatch({
    type: 'undo'
  });
}

function redo(dispatch) {
  dispatch({
    type: 'redo'
  });
}

export { CsvProvider, useCsvState, useCsvDispatch, reset, save, undo, redo };